// Returns the duration portion only: "7-day" (en) / "7 jours" (fr)
export function trialLabel(days, lang) {
  const fr = lang === 'fr';
  const d = Math.max(1, parseInt(days, 10) || 30);
  if (d >= 330) {
    const y = Math.round(d / 365);
    return fr ? `${y} an${y > 1 ? 's' : ''}` : `${y}-year`;
  }
  if (d >= 45) {
    const m = Math.round(d / 30);
    return fr ? `${m} mois` : `${m}-month`;
  }
  return fr ? `${d} jours` : `${d}-day`;
}

// Returns the full trial phrase: "7-day free trial" (en) / "7 jours d'essai gratuit" (fr)
export function trialPhrase(days, lang) {
  const label = trialLabel(days, lang);
  return lang === 'fr' ? `${label} d'essai gratuit` : `${label} free trial`;
}
